export default {
  status                    : {
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  transactionTypes: [
    { value: 'AddRestructuring', label: 'AddRestructuring' },
    { value: 'AddLoanDetail', label: 'AddLoanDetail' },
    { value: 'AddFeeDetail', label: 'AddFeeDetail' },
    { value: 'AddPayment', label: 'AddPayment' },
    { value: 'AddDaily', label: 'AddDaily' }
  ],
  filtersOptions:{
    years: [
      { value: 0, label: 'ทุกปี' },
      { value: 2021, label: '2564' },
      { value: 2020, label: '2563' },
      { value: 2019, label: '2562' },
      { value: 2018, label: '2561' }
    ],
  },
  filters: {
    year: 0
  },
}
